import API_URL from "../config/API_URL";
const API_BASE = `${API_URL}/api/stripe`;

export const stripeService = {
  /**
   * Create checkout session and redirect to Stripe
   */
  async createCheckoutSession(planType) {
    const response = await fetch(`${API_BASE}/create-checkout-session`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        plan_type: planType,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create checkout session');
    }

    const data = await response.json();
    
    // Redirect to Stripe Checkout
    window.location.href = data.url;  // ✅ Fixed: changed from data.checkout_url to data.url
  },

  /**
   * Open Stripe Customer Portal for managing subscription
   */
  async openCustomerPortal() {  // REMOVED familyId parameter
    const response = await fetch(`${API_BASE}/create-portal-session`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to open portal');
    }

    const data = await response.json();
    
    // Redirect to Stripe Portal
    window.location.href = data.url;
  },

  /**
   * Get subscription status
   */
  async getSubscriptionStatus() {  // REMOVED familyId parameter
    const response = await fetch(`${API_BASE}/subscription-status`, {
      credentials: 'include'
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch subscription status');
    }

    return response.json();
  },
};